var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('noticePc'):_c('noticeM')}
var staticRenderFns = []

export { render, staticRenderFns }